
import Multiselect from 'vue-multiselect';
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['labels'],
  components: {
    Multiselect,
  },
  props: {
    mapTypeControlEnabled: {
      type: Boolean,
      default: true,
    },
    labelsEnabled: {
      type: Boolean,
      default: true,
    },
    zoomControlEnabled: {
      type: Boolean,
      default: true,
    },
    streetViewControlEnabled: {
      type: Boolean,
      default: false,
    },
    navigationControlEnabled: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Object,
    },
    map: {
      type: Object,
      required: true,
    },
    mapContainer: {
      type: HTMLDivElement,
    },
  },
  data() {
    return {
      mapType: null as any,
      mapTypeIds: [
        { key: 'roadmap', title: 'Mapa' },
        { key: 'hybrid', title: 'Satelit' },
      ],
      googleMap: this.map as google.maps.Map,
    };
  },
  created() {
    for (var item of this.mapTypeIds) {
      item.title = this.$t('MapControls.mapTypes.' + item.key);
    }

    this.mapType = this.mapTypeIds.filter((x) => x.key === this.googleMap.getMapTypeId())[0];
  },
  computed: {
    navigationUrl(): string | null {
      return this.position ? `https://www.google.com/maps/dir/?api=1&destination=${this.position.lat},${this.position.lng}` : null;
    },
  },
  methods: {
    onMapTypeChange(value: any) {
      this.googleMap.setMapTypeId(value.key);
    },
    onZoomCurrentLocation() {
      this.getCurrentPosition()
        .then((position: any) => {
          if (position.coords) {
            const location = { lat: position.coords.latitude, lng: position.coords.longitude };
            this.googleMap.setCenter(location);
            this.googleMap.setZoom(13);
          } else {
            console.warn('Geolocation is not supported by this browser.');
          }
        })
        .catch((error) => {
          let msg = null as null | string;
          switch (error.code) {
            case error.PERMISSION_DENIED:
              msg = 'User denied the request for Geolocation.';
              break;
            case error.POSITION_UNAVAILABLE:
              msg = 'Location information is unavailable.';
              break;
            case error.TIMEOUT:
              msg = 'The request to get user location timed out.';
              break;
            case error.UNKNOWN_ERROR:
              msg = 'An unknown error occurred.';
              break;
          }
          console.warn(msg);
        });
    },
    onZoomIn() {
      let zoom = this.googleMap.getZoom();
      this.googleMap.setZoom(++zoom);
    },
    onZoomOut() {
      let zoom = this.googleMap.getZoom();
      this.googleMap.setZoom(--zoom);
    },
    onStreetView() {
      if (!this.mapContainer || !this.position) return;
      const panorama = new window.google.maps.StreetViewPanorama(this.mapContainer, {
        position: this.position as any,
        enableCloseButton: true,
      });
      this.googleMap.setStreetView(panorama);
    },
    getCurrentPosition(options?: PositionOptions) {
      if (navigator.geolocation) {
        return new Promise((resolve, reject) => navigator.geolocation.getCurrentPosition(resolve, reject, options));
      } else {
        return new Promise((resolve) => resolve({}));
      }
    },
    onShowLabels() {
      this.$emit('labels');
    },
  },
});
